export default {
    name: 'CalculatorInfoBox',
    props: {
        styles: {
            type: Object,
            required: false,
        },
        data: {
            type: Object,
            required: true,
        },
    },
    setup(props) {},
}
